// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import moment from 'moment'

import {
  SpanWithData
} from '../'


export const MessageTableRow = ({ message, messageIdentity, actionColumn, onClick }) => (
  <tr onClick={onClick} className='clickable'>
    <td className='slds-truncate'>
      {messageIdentity !== null
        ? messageIdentity.fullName
        : 'Unknown'
      }
    </td>
    <td>
      <SpanWithData forField='WhatsappMessageDirection' searchKey={message.direction} />
    </td>
    <td>
      <SpanWithData forField='WhatsappMessageStatus' searchKey={message.status} />
    </td>
    <td>
    {moment(message.createdAt).format('DD MMM YYYY HH:mm:ss')}
    </td>
    <td>
      <SpanWithData forField='WhatsappMessageMessageType' searchKey={message.messageType} />
    </td>
    <td className='slds-truncate' title={message.body}>
      {message.body}
    </td>
    {actionColumn &&
      <td onClick={e => e.stopPropagation()}>
        {actionColumn.render(
          message.id,
          messageIdentity
            ? messageIdentity.id
            : null
        )}
      </td>
    }
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/whatsapp-messages/MessageTableRow.js